import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

let stroage = {
  menus: [],
  userInfo: { roles: [] }
}

if (YJ_SCHOOL_STORAGE.getItem('userInfo')) {
  stroage.userInfo = JSON.parse(YJ_SCHOOL_STORAGE.getItem('userInfo'))
  stroage.menus = JSON.parse(YJ_SCHOOL_STORAGE.getItem('menus'))
}

const state = {
  userInfo: stroage.userInfo,
  menus: stroage.menus,
  isAdmin: false,
  randomStr: Math.random().toString(36).substr(2),
  showVerity: false,
}

export default {
  state,
  actions,
  getters,
  mutations,
}

